var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsGuestPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "passport"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.33334 13.3337H11.6667M7.33334 18.3337H12.6667C14.0668 18.3337 14.7669 18.3337 15.3017 18.0612C15.7721 17.8215 16.1545 17.439 16.3942 16.9686C16.6667 16.4339 16.6667 15.7338 16.6667 14.3337V5.66699C16.6667 4.26686 16.6667 3.5668 16.3942 3.03202C16.1545 2.56161 15.7721 2.17916 15.3017 1.93948C14.7669 1.66699 14.0668 1.66699 12.6667 1.66699H7.33334C5.93321 1.66699 5.23315 1.66699 4.69837 1.93948C4.22796 2.17916 3.84551 2.56161 3.60583 3.03202C3.33334 3.5668 3.33334 4.26686 3.33334 5.66699V14.3337C3.33334 15.7338 3.33334 16.4339 3.60583 16.9686C3.84551 17.439 4.22796 17.8215 4.69837 18.0612C5.23315 18.3337 5.93321 18.3337 7.33334 18.3337ZM12.5 7.50033C12.5 8.88104 11.3807 10.0003 10 10.0003C8.6193 10.0003 7.50001 8.88104 7.50001 7.50033C7.50001 6.11961 8.6193 5.00033 10 5.00033C11.3807 5.00033 12.5 6.11961 12.5 7.50033Z",
    stroke: "#A4A7AE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsGuestPassport);
export default __webpack_public_path__ + "static/media/as-guest-passport.0afeac6252011a5a514b01002435610e.svg";
export { ForwardRef as ReactComponent };